import React from "react";
import { EWsrvTransform } from "../../lib/Media/util";
import { ListingContact } from "./ListingContact";
import ListingDetails, { EListingDetailsLayout } from "./ListingDetails";
import { ListingSummary } from "./ListingSummary";
import { EListingVitalsLayout, ListingVitals } from "./ListingVitals";
import { IListingLayoutProps } from "./util";
import { WsrvImage } from "../Media";
import { FaPrint } from "react-icons/fa";
export const ListingLayoutPrintVersion: React.FC<IListingLayoutProps> = ({
  listing,
  linkFunc,
  agents,
  className = "",
  vitalsProps,
  contactProps,
  summaryProps,
  detailsProps,
  officeLogo,
}) => {
  const listingFullUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${listing.path}`
      : listing.path;

  const handlePrint = () => {
    typeof window !== "undefined" && window.print();
  };

  return (
    <div
      className={`${className} listing-layout layout-print-version w-[800px] justify-center mx-auto`}
    >
      <div className="flex justify-center print:hidden mt-2.5">
        <button className="flex items-center inverted p-2.5" onClick={handlePrint}>
          <FaPrint className="mr-2" /> PRINT THIS FLYER
        </button>
      </div>
      <div className="flex">
        <div className="w-2/3 pr-4">
          <div className="font-bold address">
            <h1 className="text-left">{listing.address.street1}</h1>
            <h2>
              {listing.address.city}, {listing.address.state}{" "}
              {listing.address.postal}
            </h2>
          </div>
        </div>
        <div className="w-1/3">
          {officeLogo && (
            <img
              src={officeLogo.url}
              alt="Office Logo"
              className="w-full h-auto"
            />
          )}
        </div>
      </div>
      <div className="flex">
        <div className="w-2/3 pr-4">
          {listing.images?.[0] && (
            <WsrvImage
              urlParams={{
                originURL: listing.images[0].url,
                preset: EWsrvTransform.cover3x2,
              }}
            />
          )}
        </div>
        <div className="w-1/3">
          <ListingVitals
            listing={listing}
            className="mb-3 !flex !flex-col pt-0"
            layout={EListingVitalsLayout.column1Border0}
            omitAddressParts={["city", "state", "postal"]}
            twoLineAddress={false}
            cityName={false}
            vitalIconsClassName="justify-end !flex !flex-row !flex-wrap"
            locationClassName="hidden"
            priceClassName="price !flex !flex-col"
            replaceIconsForText={true}
            showFlags={true}
            {...vitalsProps}
          />
          <ListingContact
            listing={listing}
            agents={agents}
            linkFunc={linkFunc}
            {...contactProps}
          />
        </div>
      </div>
      <div className="flex">
        <div className="w-2/3 pr-4">
          <ListingSummary
            listing={listing}
            className="py-3 mx-auto text-center"
            showCourtesy={false}
            {...summaryProps}
          />
          <div className="flex mt-5 gap-2.5">
            {listing.images?.[0] &&
              listing.images.slice(1, 3).map((image, index) => (
                <WsrvImage
                  key={index}
                  urlParams={{
                    originURL: image.url,
                    preset: EWsrvTransform.fit3x2,
                  }}
                  imgProps={{
                    loading: "eager"
                  }}
                />
              ))}
          </div>
          <div className="mt-5 text-xs">
            <p className="text-left w-full ml-[15px]">
              For full property details, please visit:<br />
              {listingFullUrl}
            </p>
          </div>
        </div>
        <div className="w-1/3">
          {listing.details && (
            <div>
              <ListingDetails
                layout={EListingDetailsLayout.groupNone}
                detailGroups={listing.details}
                {...detailsProps}
              />
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2.5 mt-5">
        {listing.images?.[0] &&
          listing.images.slice(3, 15).map((image, index) => (
            <WsrvImage
              key={index}
              urlParams={{
                originURL: image.url,
                preset: EWsrvTransform.fit3x2,
              }}
              className="w-full h-auto"
              imgProps={{
                loading: "eager"
              }}
            />
          ))}
      </div>
    </div>
  );
};
